/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VisitBalanceIntegrationViewModel } from './visitBalanceIntegrationViewModel';
import { PartnerEncounterViewModel } from './partnerEncounterViewModel';

export interface PatientBalanceIntegrationViewModel {
  /**
   * Dataset Id (not used for Add)
   */
  datasetId?: string;
  /**
   * Patient account number
   */
  accountNumber?: number;
  /**
   * Current patient balance
   */
  patientBalance?: number;
  /**
   * Current insurance balance
   */
  insuranceBalance?: number;
  /**
   * Current unapplied payment balance
   */
  unappliedBalance?: number;
  /**
   * Date of Patient\'s last statement
   */
  lastStatementDate?: string;
  /**
   * Current unapplied payment balance
   */
  lastStatementAmount?: number;
  visits?: Array<VisitBalanceIntegrationViewModel> | null;
  unpostedVisits?: Array<PartnerEncounterViewModel> | null;
}
